import { useQuery } from "@tanstack/react-query";
import type { FollowedTopicKind } from "@connect/shared";
import { useApi } from "./api";

export interface Follow {
  topic_kind: FollowedTopicKind;
  topic_value: string;
  created_at: number;
}

export function useFollows() {
  const api = useApi();
  return useQuery({
    queryKey: ["opp-follows"],
    queryFn: () => api.get<{ follows: Follow[] }>("/opportunities/follows"),
    staleTime: 30_000,
  });
}
